// alterado - revisado

const videoFuncionalidadeList = [
    {
        id: '010',
        descricao: 'Acesso à Fin-Tracks',
        ordem: '010',
    },
    {
        id: '100',
        descricao: 'Configurações',
        ordem: '100',
    },
    {
        id: '180',
        descricao: 'Configurações - Cenários',
        ordem: '180',
    },
    {
        id: '200',
        descricao: 'Configurações - Páginas',
        ordem: '200',
    },
    {
        id: '500',
        descricao: 'Clientes',
        ordem: '500',
    },
    {
        id: '505',
        descricao: 'Clientes - Cadastro',
        ordem: '505',
    },
    {
        id: '510',
        descricao: 'Clientes - Dados Básicos',
        ordem: '510',
    },
    {
        id: '520',
        descricao: 'Clientes - Simulação Financeira',
        ordem: '520',
    },
    {
        id: '574',
        descricao: 'Clientes - Estudo - Acumulação',
        ordem: '574',
    },
    {
        id: '576',
        descricao: 'Clientes - Estudo - Previdência Privada',
        ordem: '576',
    },
    {
        id: '578',
        descricao: 'Clientes - Estudo - Relatório',
        ordem: '578',
    },
]

export default videoFuncionalidadeList